// extracted by mini-css-extract-plugin
module.exports = {"root":"PatternAutocomplete_root__1-gMO","list":"PatternAutocomplete_list__295vj"};